import {
  Box,
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  Text,
} from "@chakra-ui/react";
import { textStyle } from "theme/names";
import { roundUp } from "utils/helpers";

interface Props {
  rangeTextPrefix?: string;
  rangeTextSuffix?: string;
  min: number;
  max: number;
  step: number;
  value: [number, number];
  onChange: (val: [number, number]) => void;
  unlimitedMaxValue?: boolean;
  ultimateMaxValue?: number;
  disableLeftThumb?: boolean;
}

export function LinearRangeSlider({
  rangeTextPrefix = "",
  rangeTextSuffix = "",
  min = 0,
  max = 100,
  step = 10,
  value,
  onChange,
  unlimitedMaxValue = false,
  ultimateMaxValue = max,
  disableLeftThumb = false,
}: Props) {

  const handleOnChange = (values) => {
    onChange(values);
  }

  return (
    <Box mt="3">
      <RangeSlider
        aria-label={["min", "max"]}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleOnChange}
      >
        <RangeSliderTrack>
          <RangeSliderFilledTrack />
        </RangeSliderTrack>
        {
          !disableLeftThumb && 
          <RangeSliderThumb index={0} boxSize="4" />
        }
        <RangeSliderThumb index={1} boxSize="4" />
      </RangeSlider>
      <Text textStyle={textStyle["body.medium.light"]} mt="2">
        {rangeTextSuffix}
        {
          (disableLeftThumb)
          ? " "
          : " " + roundUp(value[0], 0) + " - "
        }
        {unlimitedMaxValue &&
        (value[1] === max || value[1] === ultimateMaxValue)
          ? "unlimited"
          : roundUp(value[1], 0)}{" "}
        {rangeTextPrefix}
      </Text>
    </Box>
  );
}
